import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/globals.css';

// After a redeploy, an already-open (or SW-cached) app may request chunk
// hashes that no longer exist. Reload once to pick up the new build.
window.addEventListener('vite:preloadError', (event) => {
  const key = 'chunk-reload-at';
  let last = 0;
  try { last = Number(sessionStorage.getItem(key) ?? 0); } catch { /* storage blocked */ }
  if (Date.now() - last < 10_000) return; // avoid reload loops
  try { sessionStorage.setItem(key, String(Date.now())); } catch { /* storage blocked */ }
  event.preventDefault();
  window.location.reload();
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,   // always re-fetch on mount so newly created data appears immediately
      retry: 1,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
